import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import Modal from '~/components/Modal/Modal';
import NotificationSettings from '~/components/NotificatioinSettings/NotificationSettings';

import { useModal } from '../../hooks/useModal';

import Icon from '../Icon/Icon';

const ModalChangeNotifications = () => {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  const backHandler = () => closeModal();

  return (
    <Modal
      isShow={true}
      className="modal-change-notifications__body"
      onBackdropDismiss={backHandler}
    >
      <div className="popover-container input-form">
        <div className="popover">
          <header className="popover__header">
            <button
              className="button _no-padding _no-color back-button"
              onClick={backHandler}
            >
              <Icon type="arrow" className="icon__rotate-180" size={24} />
            </button>
            <div className="title">{t('notificationSettings')}</div>
          </header>
          <button
            className="button _no-padding _no-color input-form__close"
            onClick={backHandler}
          >
            <Icon type="plus" className="icon__rotate-45" size={36} />
          </button>
          <NotificationSettings />
        </div>
      </div>
    </Modal>
  );
};

export default observer(ModalChangeNotifications);
